import { RoleDto } from '../../../../api';
import { useForm, FormProvider, NestedValue, SubmitHandler } from 'react-hook-form';
import { Grid, Button } from '@mui/material';
import { TextField } from '../../../../components/form/react-hook-form-components';
import useFormStyles from './../../../../styles/useFormStyles';

interface IRoleFormProps {
  onSubmit: (values: RoleDto) => void;
  onCancel: () => void;
  roleNameSuggestion?: string;
}

interface IRoleFormFields {
  name: string | null;
}

/**
 * The form for creating and updating projects
 */
function RoleForm(props: IRoleFormProps) {
  const classes = useFormStyles();
  const { onSubmit, onCancel, roleNameSuggestion } = props;

  const methods = useForm<IRoleFormFields>({
    defaultValues: {
      name: roleNameSuggestion,
    },
  });

  const { handleSubmit } = methods;

  /**
   * Submit form data
   * @param data form fields input data
   */
  const submit: SubmitHandler<IRoleFormFields> = data => {
    onSubmit({
      name: data.name,
    } as RoleDto);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submit)}>
        <Grid container spacing={1.5} width="25rem">
          <Grid item xs={12}>
            <TextField name="name" label="Role Title" required autoFocus />
          </Grid>

          <Grid item container direction="row" justifyContent="end" spacing={1}>
            <Grid item>
              <Button variant="contained" size="large" type="submit" className={classes.submitButton}>
                {'Create'}
              </Button>
            </Grid>

            <Grid item>
              <Button variant="outlined" color="neutral" size="large" onClick={onCancel}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}

export default RoleForm;
